import { sortAlphabeticallyByKey, values } from '@fortem-monorepo/js-utilities';
export const INSTRUMENT_TYPE = {
    FxFwd: 'fxfwd',
    Bond: 'bond',
    Equity: 'equity',
    Index: 'index',
    Fund: 'fund',
    DiverOtc: 'diver-otc',
    EquityOtc: 'equity-otc',
    Aswap: 'aswap',
    AutocallStandard: 'autocall-standard',
    AutocallConsolation: 'autocall-consolation',
    AutocallPhoenix: 'autocall-phoenix',
    Digital: 'digital',
    VanillaSpread: 'vanilla-spread',
    VanillaStructured: 'vanilla-structured',
    RangeAccrual: 'range-accrual',
    Supertracker: 'supertracker',
    Other: 'other',
    Vanilla: 'vanilla',
    VanillaDigital: 'vanilla-digital',
};
export const INSTRUMENT_TYPES = values(INSTRUMENT_TYPE);
const INSTRUMENT_TYPE_LABELS = {
    bond: 'Bond',
    aswap: 'Aswap',
    digital: 'Digital',
    equity: 'Equity',
    fund: 'Fund',
    fxfwd: 'FxFwd',
    index: 'Index',
    'diver-otc': 'Diver OTC',
    'equity-otc': 'Equity OTC',
    'autocall-standard': 'Autocall Standard',
    'autocall-consolation': 'Autocall Consolation',
    'autocall-phoenix': 'Phoenix Non-Memory',
    'vanilla-spread': 'Call / Put Spread',
    'vanilla-structured': 'Call / Put Structured',
    'range-accrual': 'Range Accrual',
    supertracker: 'Supertracker',
    vanilla: 'Vanilla',
    'vanilla-digital': 'Vanilla Digital',
    other: 'Other',
};
export const INSTRUMENT_TYPE_OPTIONS = sortAlphabeticallyByKey(INSTRUMENT_TYPES.map((i) => ({
    label: INSTRUMENT_TYPE_LABELS[i],
    value: i,
})), 'label');
